import { Controller } from 'stimulus';

class CountdownController extends Controller {
  connect() {
    if (!this.data.get('date').length) {
      return;
    }

    this.date = new Date(this.data.get('date')).getTime();

    this.countdown();
  }

  countdown() {
    const interval = setInterval(() => {
      const currentDate = new Date().getTime();
      const difference = this.date - currentDate;

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      const daysElement = this.element.querySelector('[data-type="days"]');
      const hoursElement = this.element.querySelector('[data-type="hours"]');
      const minutesElement = this.element.querySelector('[data-type="minutes"]');
      const secondsElement = this.element.querySelector('[data-type="seconds"]');

      if (days <= 0) {
        if (daysElement) {
          daysElement.parentNode.removeChild(daysElement);
        }

        if (hoursElement && hours <= 0) {
          hoursElement.parentNode.removeChild(hoursElement);
        }
      }

      if (daysElement) {
        daysElement.querySelector('.digit').innerText = days;
        daysElement.querySelector('.suffix').innerText = days === 1 ? window.app.i18n.day : window.app.i18n.days;
      }

      if (hoursElement) {
        hoursElement.querySelector('.digit').innerText = hours;
        hoursElement.querySelector('.suffix').innerText = window.app.i18n.hour;
      }

      minutesElement.querySelector('.digit').innerText = minutes;
      minutesElement.querySelector('.suffix').innerText = minutes === 1 ? window.app.i18n.minute : window.app.i18n.minutes;

      secondsElement.querySelector('.digit').innerText = seconds;
      secondsElement.querySelector('.suffix').innerText = seconds === 1 ? window.app.i18n.second : window.app.i18n.seconds;

      this.element.removeAttribute('hidden');

      if (difference < 0) {
        clearInterval(interval);
        this.element.setAttribute('hidden', 'hidden');
      }
    }, 1000);
  }
}

CountdownController.targets = [
  //
];

export default CountdownController;
